import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

import { isEmptyOrNil } from 'libs/empty'

const StyledTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.primary[300],
    fontSize: '12px',
    padding: '8px 12px',
    lineHeight: '1.4',
  },
  arrow: {
    color: theme.palette.primary[300],
  },
}))(Tooltip)

const PrimaryTooltip = (props) => {
  const { title, children, ...restProps } = props

  // If no title, just render children without tooltip wrapper
  if (isEmptyOrNil(title)) {
    return <>{children}</>
  }

  return (
    <StyledTooltip title={title} arrow={true} {...restProps}>
      {children}
    </StyledTooltip>
  )
}

PrimaryTooltip.propTypes = {
  children: PropTypes.node,
  title: PropTypes.any,
}
export default PrimaryTooltip
